













import Vue from 'vue';
import DesignForm, { FormDataInterface } from '@/containers/cv-design/form.vue';
import * as CvDesignStore from '@/containers/cv-design/store';
import { Cv, CvDesignTemplateSample } from '@/../gen';
import { i18n, i18nHints } from '@/plugins/i18n';
export default Vue.extend({
  components: {
    DesignForm,
  },
  props: {
    cv: {
      type: Object as () => Cv,
      required: true,
    },
    cvDesignTemplateSamples: {
      type: Array as () => CvDesignTemplateSample[],
      required: true,
    },
  },
  methods: {
    async onSubmit({ cv_design_template_id }: FormDataInterface) {
      const { id } = this.cv;
      await this.$store.dispatch(
        CvDesignStore.UpdateCv.namespaced({
          params: { id },
          body: {
            cv_design_template_id,
          },
        })
      );
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.updated));
      // NOTE: go to preview page
      this.$router.push({
        name: 'cv_preview_path',
        params: { cv_id: id },
      });
    },
  },
});
